export default __webpack_public_path__ + "static/media/cloudIcon.1e1b1afb.svg";